<template>
  <div class="subtitle-section">
    {{ content }}
  </div>
</template>

<script>
  export default {
    name: "subtittle-section",
    props: ['content']
  };
</script>

<style scoped>

  .subtitle-section {
    @apply bg-grey-bg text-base text-grey-text text-center p-3.5 font-normal;
  }

  @screen lg {
    .subtitle-section {
      @apply hidden;
    }
  }
</style>
